import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem('token') || '');
  const [isAuthenticated, setIsAuthenticated] = useState(null); // null로 초기화
  const [isLoading, setIsLoading] = useState(true); // 로딩 상태 추가
  const [sUserName, setSUserName] = useState(''); 

  const saveToken = (newToken) => {
    setToken(newToken);
    localStorage.setItem('token', newToken);
    setIsAuthenticated(true);
    setIsLoading(false);
  };

  const deleteToken = () => {
    setToken(null);
    localStorage.removeItem('token');
    setIsAuthenticated(false);
    setIsLoading(false);
  };

  const verifyToken = useCallback(() => {
    const fetchToken = async () => {
      if (!token) {
        setIsAuthenticated(false);
        setIsLoading(false);
        return;
      }

      try {
        const response = await axios.post(process.env.REACT_APP_SERVER_URL + '/main/verify', {}, {
          headers: { Authorization: `Bearer ${token}` }
        });

        if (response.data.userId === '') {
          setIsAuthenticated(false);
          localStorage.removeItem('token');
        } else {
          setIsAuthenticated(true); 
          setSUserName(response.data.name);
        }
      } catch (error) {
        setIsAuthenticated(false);
        localStorage.removeItem('token');
      }
      setIsLoading(false); // 검증 완료 후 로딩 해제
    };

    fetchToken();
  }, [token]);

  useEffect(() => {
    verifyToken();
  }, [verifyToken]);

  return (
    <AuthContext.Provider value={{ token, saveToken, deleteToken, isAuthenticated, isLoading, sUserName }}>
      {children}
    </AuthContext.Provider>
  );
};
